// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"220":"a505af14","276":"a505af14","339":"d1de308c","761":"a505af14"}[chunkId] + ".chunk.css";
};